var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-md": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-flex",
                { attrs: { md12: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c("v-flex", { staticClass: "flex-column" }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Asignación\n                  "
                                        )
                                      ]
                                    ),
                                    _c("div", [
                                      _vm._v("Vehículo | Transportista")
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { staticClass: "flex-column" },
                                [
                                  _c("AsignacionFiltroPlataforma", {
                                    ref: "asignacionPlataforma"
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-container",
                            [
                              _c("AsignacionBusqueda", {
                                ref: "asignacionBusqueda"
                              }),
                              _c(
                                "v-card",
                                [
                                  _c("TabGridSeleccion", {
                                    ref: "asignacionSeleccion"
                                  })
                                ],
                                1
                              ),
                              _c("AsignacionPersonal", {
                                ref: "asignacionPersonal"
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }